import { Autocomplete, SxProps, TextField } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { Person } from '@src/types/Person'
import { useTranslation } from 'react-i18next'

interface ExceptionPersonFilterAutoCompletePrpos {
  persons: Person[]
  selectedPerson: Person | null
  onPersonChange: (person: Person | null) => void
  sx?: SxProps<Theme>
}

const ExceptionPersonFilterAutoComplete = ({
  persons,
  selectedPerson,
  onPersonChange,
  sx,
}: ExceptionPersonFilterAutoCompletePrpos) => {
  const { t } = useTranslation()

  const handlePersonChange = (_event: React.SyntheticEvent, person: Person | null) => {
    onPersonChange(person)
  }

  return (
    <Autocomplete
      options={persons}
      getOptionLabel={(option) => option.fullName || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      filterSelectedOptions
      renderInput={(params) => <TextField {...params} label={t('common.filter')} />}
      onChange={handlePersonChange}
      value={selectedPerson}
      sx={sx}
    />
  )
}

export default ExceptionPersonFilterAutoComplete
